import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CompanyDataAnalysisOptions, defaultChartOrTableHeight } from './CompanyDataAnalysisService';
import { Symbols } from '@/symbols';
import { CompanyDataAnalysisViewType } from './CompanyDataAnalysis.type';
import { CompanyDataAnalysisKeyType } from '@/apis/service/company/CompanyDataAnalysisApi.type';
import _ from 'lodash';
let CompanyCopilotDataAnalysisService = class CompanyCopilotDataAnalysisService {
    constructor(companyDataAnalysisApi, companyDataAnalysisService, i18n) {
        this.companyDataAnalysisApi = companyDataAnalysisApi;
        this.companyDataAnalysisService = companyDataAnalysisService;
        this.i18n = i18n;
        this.instancesCopilotOption = new CompanyDataAnalysisOptions();
        this.copilotConfigInit();
    }
    copilotConfigInit() {
        this.instancesCopilotOption.reportName = CompanyDataAnalysisKeyType.COPILOT;
        this.instancesCopilotOption.title = this.i18n.t('backoffice.company.dataAnalysis.patsnapCopilot');
        this.instancesCopilotOption.explain = this.i18n.t('backoffice.company.dataAnalysis.analytics');
        this.instancesCopilotOption.chartId = 'copilotAnalysis';
        this.instancesCopilotOption.viewType = CompanyDataAnalysisViewType.Chart;
        this.instancesCopilotOption.canChangeViewType = true;
        this.instancesCopilotOption.canCollapse = true;
        this.instancesCopilotOption.chartHeight = defaultChartOrTableHeight.defaultChartHeightWithTopBox;
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            total_count: this.i18n.t('backoffice.company.dataAnalysis.copilotPv'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.copilotUv'),
        };
        this.instancesCopilotOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.instancesCopilotOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
    }
    getCopilotData(params) {
        this.instancesCopilotOption.loading = true;
        const copilotParams = _.cloneDeep(params);
        copilotParams.report_name = this.instancesCopilotOption.reportName;
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(copilotParams).then(data => {
            this.instancesCopilotOption.Updated = data.data_date;
            this.instancesCopilotOption.noData = data.data_detail.length === 0;
            const statistics = {
                total_count: data.total_count,
                user_count: data.user_count,
                key: 'copilot',
            };
            this.instancesCopilotOption.statistics = this.companyDataAnalysisService.getPvUvStatistics(statistics);
            this.instancesCopilotOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, this.instancesCopilotOption.reportName);
            const optionParams = {
                data: data.data_detail,
                total_count: this.instancesCopilotOption.statistics[0].label,
                user_count: this.instancesCopilotOption.statistics[1].label,
                key: this.instancesCopilotOption.reportName,
            };
            this.instancesCopilotOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.instancesCopilotOption.noData = true;
        }).finally(() => {
            this.instancesCopilotOption.loading = false;
        });
    }
    initData(params) {
        Promise.all([
            this.getCopilotData(params)
        ]);
    }
};
CompanyCopilotDataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyDataAnalysisApi)),
    __param(1, inject(Symbols.CompanyDataAnalysisService)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CompanyCopilotDataAnalysisService);
export { CompanyCopilotDataAnalysisService };
